<div class="messages-indicator-widget">
  <div class="icon-container">
    <svg class="envelope-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>

    <div class="badge" *ngIf="unreadCount > 0">
      <span class="badge-text">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </div>
  </div>
</div>
